<template>
  <div class="user-center">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'UserCenterSlot'
}
</script>

<style lang="less">
@import '../../global/variable';
.user-center{
    .userCenterContainerMinHeight();
    padding: 40px 0 104px;
    background-color: var(--src-text-color-white-dark1);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/UserCenterSlot.vue